import { tm } from '../tm'
import type { CSSProperties } from 'react'
import './Skeletons.css'

const VARIANTS = {
  large: 'h-32 w-32',
  medium: 'h-28 w-28',
  small: 'h-16 w-16',
}

type SkeletonCircleVariant = keyof typeof VARIANTS
interface SkeletonCircleProps {
  className?: string
  style?: CSSProperties
  variant: SkeletonCircleVariant
}

const emptyObject = {}
export function SkeletonCircle({
  className = '',
  style = emptyObject,
  variant,
}: SkeletonCircleProps) {
  return (
    <div
      className={tm(
        'skeleton-wave-animation rounded-full',
        VARIANTS[variant],
        className,
      )}
      style={style}
    />
  )
}
